import { EOfficeType, Filters } from 'shared/types/filters';

export function hasCoworkingOfficeType(filters: Filters): boolean {
  return filters.officeType.includes(EOfficeType.Coworking);
}
